module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-tested-solutions.pl@2x-136d0f0e7546f6f170dcbad0526f7511.png";